import { Link } from "@mui/material";
import { type FC } from "react";
import { NavLink } from "react-router";

import { SOCIAL_LINKS } from "~/constants/socials";

import packageJson from "../../../../../package.json";
import { LEGAL_LINKS } from "../../constants";
import * as Styled from "./FooterBottom.styles";

export const FooterBottom: FC = () => {
  return (
    <>
      <Styled.SocialRow>
        <Styled.SocialList>
          {SOCIAL_LINKS.map(({ to, Icon }) => (
            <Styled.SocialLink
              key={to}
              component="a"
              href={to.trim()}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon />
            </Styled.SocialLink>
          ))}
        </Styled.SocialList>
      </Styled.SocialRow>

      <Styled.FinePrintRow component="p">
        {LEGAL_LINKS.map(({ label, to }) => (
          <Styled.FinePrintLink key={label} component={NavLink} to={to}>
            {label}
          </Styled.FinePrintLink>
        ))}
        <Styled.Copyright>
          PredictionHero © 2026 · v{packageJson.version}
        </Styled.Copyright>
      </Styled.FinePrintRow>

      <Styled.LegalText component="p">
        PredictionHero provides aggregated market data and informational signals
        only. Nothing on this site constitutes financial, legal, or investment
        advice. Markets are volatile and speculative. Past performance does not
        guarantee future results. Always do your own research and consult
        qualified professionals before making decisions involving risk. This
        site is protected by reCAPTCHA and the{" "}
        <Link
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          underline="always"
        >
          Google Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          underline="always"
        >
          Terms of Service
        </Link>{" "}
        apply.
      </Styled.LegalText>
    </>
  );
};
